module.exports = __webpack_public_path__ + "img/libra-2.7caf7840.png";